(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvEntityTemplateSelector', drvEntityTemplateSelector);

    drvEntityTemplateSelector.$inject = [];
    
    /**
     * User interface for selecting an active standalone entity template.
     *
     * # Scope Properties
     * {string} label - The label/name to be shown for the control. Optional. If not supplied the control will default to showing 'Entity Template'.
     * {array} entityTemplates - An array of entity templates from EntityTemplatesService.
     * {object} selectedEntityTemplate - The selected entity template, an object from the entityTemplates array.
     * {string} placeHolder - The label/name to be shown in the control when no value has been selected. Optional.
     * {bool} required - Value must be selected. Optional.
     * {bool} disabled - Disables the control. Optional.
     * {function} selectedItemChanged - A function called when the selected item changes.
     * {array/string} valueProperties - Can be array for multiple properties or string for a single property.
     *                                  They will be used to construct a custom value object, this is the format which will be used with entity template.
     *                                  If not supplied, the unmodified entity template will be used. Optional.
     */
    function drvEntityTemplateSelector() {
        var directive = {
            link: link,
            restrict: 'E',
            controller: EntityTemplateSelectorCtrl,
            templateUrl: 'app/EntityTemplate/entity-template-selector.tmpl.html',
            controllerAs: 'vm',
            scope: {},
            bindToController: {
                label: '<?',
                entityTemplates: '<',
                selectedEntityTemplate: '=?',
                placeHolder: '@?',
                required: '<?',
                disabled: '<?',
                selectedItemChanged: '&?',
                valueProperties: '<?'
            }
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }

    EntityTemplateSelectorCtrl.$inject = [];

    function EntityTemplateSelectorCtrl() {
        var vm = this;
        Object.defineProperty(vm, 'filteredEntityTemplates', { get: getFilteredEntityTemplates });

        /*
         * Get the filtered entity templates
         *
         * @returns {array} - List of filtered entity templates
         */
        function getFilteredEntityTemplates() {
            var filteredEntityTemplates = _.filter(vm.entityTemplates, function (entityTemplate) { return entityTemplate.Standalone && entityTemplate.Active; });

            if (!_.isEqual(getFilteredEntityTemplates.filteredEntityTemplates, filteredEntityTemplates)) {
                getFilteredEntityTemplates.filteredEntityTemplates = filteredEntityTemplates;
            }

            return getFilteredEntityTemplates.filteredEntityTemplates;
        }
    }
})();